import { actionCreator } from '@blink/components/src/utils';

import { Token } from 'src/api/borrow';
import { SET_TOKENS } from './constants';

export const setTokensAction = (payload: Token[]) => actionCreator(SET_TOKENS, payload);
